// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400&family=Roboto:wght@300;400;500;700;900&family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Source+Serif+Pro:ital,wght@1,300&display=swap');
 */
 /* *{
   font-family: 'Bebas Neue'!important;
   letter-spacing: 1px; 
  } */
  /* @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300&display=swap'); */
  *{
    font-family: 'Poppins', sans-serif;
  }
  /*  */
  /*  */

:root {
  --Black: rgb(0,0,0);
  --Red: linear-gradient(245deg, rgba(0,0,0,1) 69%, rgba(255,0,0,1) 100%); 
}


/* * {
  margin: 0px;
  padding: 0px;
  font-family: tekton-pro, sans-serif! important;
   font-style: normal ; 
   
}
@font-face {
  font-family: 'tekton-pro';
  src: url(./fonts/TektonPro-Regular.otf) format('opentype');
} */

.laptop{
  transition-duration:1s;
}
.laptop:hover{
  scale: 1.2;
}
.image{width: 100%; height: 350px;}
.explorebtn:hover{scale: 1.1;transition-duration:1s}
.carousel-item h4 {text-align: center;}
.carousel-item .btn {border: 1px solid black;padding: 5px; color: white;}
.carousel-item .row .col-12:hover {width: 100%;height: 110%;}
.carousel-item img{border-radius: 10px;}
.caro:hover{scale: 1.1;}

@media screen and (min-width:992px) and (max-width:1200px) {
  .image{height: 230px;}
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;CACD;;;KAGI;EACH,wFAAwF;EAExF;IACE,kCAAkC;EACpC;EACA,KAAK;EAEL,KAAK;;AAEP;EACE,mBAAmB;EACnB,uEAAuE;AACzE;;;AAGA;;;;;;;;;;GAUG;;AAEH;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA,OAAO,WAAW,EAAE,aAAa,CAAC;AAClC,kBAAkB,UAAU,CAAC,sBAAsB;AACnD,mBAAmB,kBAAkB,CAAC;AACtC,qBAAqB,uBAAuB,CAAC,YAAY,EAAE,YAAY,CAAC;AACxE,mCAAmC,WAAW,CAAC,YAAY,CAAC;AAC5D,mBAAmB,mBAAmB,CAAC;AACvC,YAAY,UAAU,CAAC;;AAEvB;EACE,OAAO,aAAa,CAAC;AACvB","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Source+Serif+Pro:ital,wght@1,300&display=swap');\r\n */\r\n /* *{\r\n   font-family: 'Bebas Neue'!important;\r\n   letter-spacing: 1px; \r\n  } */\r\n  /* @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300&display=swap'); */\r\n  @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400&family=Roboto:wght@300;400;500;700;900&family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\r\n  *{\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n  /*  */\r\n  @import url('https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap');\r\n  /*  */\r\n\r\n:root {\r\n  --Black: rgb(0,0,0);\r\n  --Red: linear-gradient(245deg, rgba(0,0,0,1) 69%, rgba(255,0,0,1) 100%); \r\n}\r\n\r\n\r\n/* * {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  font-family: tekton-pro, sans-serif! important;\r\n   font-style: normal ; \r\n   \r\n}\r\n@font-face {\r\n  font-family: 'tekton-pro';\r\n  src: url(./fonts/TektonPro-Regular.otf) format('opentype');\r\n} */\r\n\r\n.laptop{\r\n  transition-duration:1s;\r\n}\r\n.laptop:hover{\r\n  scale: 1.2;\r\n}\r\n.image{width: 100%; height: 350px;}\r\n.explorebtn:hover{scale: 1.1;transition-duration:1s}\r\n.carousel-item h4 {text-align: center;}\r\n.carousel-item .btn {border: 1px solid black;padding: 5px; color: white;}\r\n.carousel-item .row .col-12:hover {width: 100%;height: 110%;}\r\n.carousel-item img{border-radius: 10px;}\r\n.caro:hover{scale: 1.1;}\r\n\r\n@media screen and (min-width:992px) and (max-width:1200px) {\r\n  .image{height: 230px;}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
